<template>
    <div class="menu_level2 flex-col">
        <div class="section_1 flex-row">
            <img
                    class="image_go_back"
                    @click="back"
                    referrerpolicy="no-referrer"
                    src="../../assets/header/mobile_menu_icon_left.png"
            />
            <span class="text_menu_title">菜单</span>
            <img
                    class="menu_close"
                    @click="closeMenu"
                    referrerpolicy="no-referrer"
                    src="../../assets/header/mobile_menu_bj04.png"
            />
        </div>
        <div class="section_2 flex-col">
            <div class="text-wrapper_1 flex-col"><span class="text_current_menu">{{menuItem.label}}</span></div>
            <div class="list_1 flex-col">
                <div class="list-items_1 flex-row justify-between"
                     v-for="(item, index) in menuItem.subItems"
                     @click="goto(item.href)"
                     :key="index"
                >
                    <span class="text_menu_name" v-html="item.label"></span>
                    <img class="image_2" referrerpolicy="no-referrer" src="../../assets/header/mobile_menu_arr.png" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                /*
                menuItem: {
                    id:1,
                    label:'核心业务',
                    child:[
                        {
                            href:'',
                            label: '渠道风控管理',
                            lanhuimage0:'',
                        },
                    ]
                },

                 */

            };
        },
        props: {
            menuItem: {
                type: Object,
                required: true
            }
        },
        methods: {
            back(){
                this.$emit('back');
            },
            closeMenu(){
                this.$emit('closeSub');
            },
            // 辅助方法，用于滚动到指定的锚点
            scrollToAnchor(anchor) {
                this.closeMenu();
                const element = document.getElementById(anchor);
                if (element) {
                    // 使用 scrollIntoView 平滑滚动到目标元素
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            },
            goto(url){
                url = '/' + url;
                if (url.includes('#')) {
                    let check = url.split('#')[0];
                    if (this.$route.path === check){
                        this.scrollToAnchor(url.split('#')[1]);
                    }else{
                        this.$router.push(url).then(() => {
                            this.scrollToAnchor(url.split('#')[1]);
                        });
                    }
                } else {
                    if (this.$route.path !== url){
                        this.$router.push(`${url}`).then(() => {
                            window.scrollTo(0, 0);
                        });
                    }else{
                        window.scrollTo(0, 0);
                    }
                }
            },
            gotoSub(url){

                url = '/' + url;
                if (url.includes('#')) {
                    this.$router.push(url).then(() => {
                        this.scrollToAnchor(url.split('#')[1]);
                    });
                } else {
                    if (this.$route.path !== url){
                        this.$router.push(`${url}`).then(() => {
                            window.scrollTo(0, 0);
                        });
                    }else{
                        window.scrollTo(0, 0);
                    }
                }
            },
        }
    };
</script>
<style scoped lang="css" >
    .menu_level2 {
        background-color: rgba(255, 255, 255, 1);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: 99999 !important;
        overflow: hidden;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .section_1 {
        background: url(../../assets/header/mobile_menu_bj01.png) 100% no-repeat;
        background-size: 100% 100%;
        padding: 24px 28px 21px 48px;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .image_go_back {
        cursor: pointer;
        width: 17px;
        height: 34px;
        margin: 4px 0 7px 0;
    }

    .text_menu_title {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        text-align: left;
        white-space: nowrap;
        line-height: 45px;
        margin-left: 24px;
    }

    .menu_close {
        position: absolute;
        right: 20px;
        cursor: pointer;
        width: 36px;
        height: 36px;
        margin: 2px 0 7px auto;
    }

    .section_2 {

    }

    .text-wrapper_1 {

        background: url(../../assets/header/mobile_menu_bj06.png)
        100% no-repeat;
        background-size: 100% 100%;
        padding: 26px 597px 24px 41px;
    }

    .text_current_menu {
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }

    .list_1 {
        height: 270px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .list-items_1 {
        cursor: pointer;
        width: 100%;
        background: #FFFFFF;
        box-shadow: inset 0px -1px 0px 0px #E8E8E8;
        background-size: 100% 100%;
        padding: 20px 25px 30px 41px;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .text_menu_name {
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 28px;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }

    .image_2 {
        position: absolute;
        right: 40px;
        width: 10px;
        height: 21px;
        margin: 9px 0 10px auto;
    }


    @media (max-width: 680px) {
        .section_1 {
            padding: 7px 20px 7px 28px;
        }
        .text_menu_title {
            font-size: 20px;
            margin-left: 20px;
        }
        .menu_close {
            cursor: pointer;
            width: 20px;
            height: 20px;
            margin: 13px 0 13px auto;
        }

        .list-items_1 {
            padding: 12px 10px 12px 25px;
        }
        .text_current_menu {
            font-size: 20px;
            line-height: 30px;
            margin-left: -20px;
        }
        .text_menu_name {
            font-size: 20px;
            line-height: 30px;
        }
        .image_2 {
            right: 20px;
            margin: 5px 0 10px auto;
        }
    }

</style>
